<template>
    <div>
        <h3>公開日の設定</h3>
        <div>
            <p>
                公開日は小説本文の編集画面から設定するか、本文一覧でそれぞれの公開日を指定します。
                本文一覧では、複数の本文の公開日を等間隔に一括設定することができます。
            </p>
            <h4>小説本文の編集画面から設定する</h4>
            <p>
                本文の編集画面で「公開」ボタンを押すと、公開設定ウインドウが開きます。
                「今すぐ公開」か「時間を指定して公開」を選べます。
                「時間を指定して公開」を選択すると、日時の設定欄が表示されます。
                公開を確定すると、編集中の本文が保存され、エピソードが公開されます。
            </p>
            <p>
                長編作品で、次の本文より公開日時が未来に設定されると、エラーになります。
                また、前の本文より過去を設定すると、エラーになります。
            </p>
            <p class="text-danger">
                指定した本文以前のエピソードが下書きの場合、それらも同一の日時に自動的に公開されます。
            </p>
            <h4>本文一覧から設定する</h4>
            <p>
                本文一覧の公開日時（あるいは下書きの文字）をクリックすると、日時設定画面が表示されます。
                ここで当該本文の公開日時を設定できます。
                既に公開日時が設定されている場合、下書きに戻すことができます。
            </p>
            <h5>公開日時の一括指定</h5>
            <img src="/img/help/novel/20.png" alt="公開日時指定" class="img-thumbnail mb-3">
            <p>
                本文一覧から公開日時を設定する場合、指定した本文以降の公開日を一括変更することができます。
                例えば、第１話を2021年3月14日 23時00分に設定し、
                <b>これ以降の公開日を１日毎(24時間)に上書き</b>
                を適用すると、３月１４日から２４時間毎に公開する設定ができます。
            </p>
            <img src="/img/help/novel/21.png" alt="公開日時確定" class="img-thumbnail mb-3">
            <p>
                本文一覧から公開日時を指定すると、一旦<b>仮状態</b>となります。
                この状態では公開日時は確定されていません。
                一括設定時は「予定 更新」ボタンをクリックして、指定日時を必ず確定してください。
            </p>
            <h5>途中を設定する</h5>
            <p>
                下書きエピソードの途中で公開日時を設定すると、それ以前の下書きはすべて同一の時間で公開されます。
            </p>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>本文</th>
                            <th>公開日時指定</th>
                            <th>→</th>
                            <th>適用日時</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr> <td>第１話</td> <td>下書き</td> <td>→</td> <td class="text-success">2021-04-05 10:00</td> </tr>
                        <tr> <td>第２話</td> <td>下書き</td> <td>→</td> <td class="text-success">2021-04-05 10:00</td> </tr>
                        <tr> <td>第３話</td> <td>下書き</td> <td>→</td> <td class="text-success">2021-04-05 10:00</td> </tr>
                        <tr> <td>第４話</td> <td class="text-success">2021-04-05 10:00</td> <td>→</td> <td class="text-success">2021-04-05 10:00</td> </tr>
                        <tr> <td>第５話</td> <td>下書き</td> <td>→</td> <td>下書き</td> </tr>
                    </tbody>
                </table>
            </div>
            <h5>途中を下書きにする</h5>
            <p>
                公開日時が設定されているエピソードの途中を下書きに設定しても、次のエピソードの公開日時が自動設定されます。
                途中の１話だけ下書きに戻すことはできません。
            </p>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>本文</th>
                            <th>公開日時指定</th>
                            <th>→</th>
                            <th>適用日時</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr> <td>第１話</td> <td>2021-04-05 10:00</td> <td>→</td> <td>2021-04-05 10:00</td> </tr>
                        <tr> <td>第２話</td> <td>2021-04-05 11:00</td> <td>→</td> <td>2021-04-05 11:00</td> </tr>
                        <tr> <td>第３話</td> <td class="text-success">下書き</td> <td>→</td> <td class="text-success">2021-04-05 13:00</td> </tr>
                        <tr> <td>第４話</td> <td>2021-04-05 13:00</td> <td>→</td> <td>2021-04-05 13:00</td> </tr>
                    </tbody>
                </table>
            </div>
            <h4>本文の順番変更と公開日</h4>
            <p>
                本文はドラッグすることで順番を変更することができます。
                すでに公開日が設定されている状態で順番変更する場合、順番を変更した結果、
                公開日が昇順にならないときはエラーとなり、順番の変更を確定することができません。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "公開日の設定 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>